import { create } from 'zustand';

import { newEmailReducer } from '@/views/emails/context/NewEmails.reducer.ts';
import { NewEmailContextProps } from '@/views/emails/context/NewEmails.types.ts';

export const useNewEmailStore = create<NewEmailContextProps>(set => ({
  autosavePaused: false,
  newEmailState: null,
  setAutosavePaused: action => {
    set(state => ({
      autosavePaused: typeof action === 'function' ? action(state.autosavePaused) : action,
    }));
  },
  updateNewEmailState: action => {
    set(state => ({
      newEmailState: newEmailReducer(state.newEmailState, action),
    }));
  },
}));
